import {html} from 'lit';
import type {Forecast} from '../weather';

const getTemperature = (forecast: Forecast) => html`
  ${forecast.hasDetailedForecasts
    ? forecast.forecastDailyAverage.temperature
    : forecast.forecastDailyAverage.maxTemperature}&nbsp;&deg;C
`;

export {getTemperature};
